import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "pontaj-page" }
const _hoisted_2 = { class: "pontaj-inner" }
const _hoisted_3 = { class: "hero" }
const _hoisted_4 = { class: "hero-actions" }
const _hoisted_5 = { class: "stat-chip" }
const _hoisted_6 = { class: "stat-val" }
const _hoisted_7 = { class: "stat-chip" }
const _hoisted_8 = { class: "stat-val" }
const _hoisted_9 = { class: "stat-chip" }
const _hoisted_10 = { class: "stat-val" }
const _hoisted_11 = { class: "filter-bar" }
const _hoisted_12 = { class: "cal-card" }
const _hoisted_13 = { class: "cal-head" }
const _hoisted_14 = { class: "cal-weekdays" }
const _hoisted_15 = { class: "cal-grid" }
const _hoisted_16 = { class: "cell-day" }
const _hoisted_17 = { class: "cell-ore" }
const _hoisted_18 = { class: "grid-card" }
const _hoisted_19 = { class: "grid-head" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "hero-txt" }, [
          _createElementVNode("div", { class: "hero-eyebrow" }, "PORTAL HR"),
          _createElementVNode("h1", { class: "hero-title" }, "Pontaj"),
          _createElementVNode("p", { class: "hero-sub" }, "Situația orelor lucrate pentru luna selectată.")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-clock-check-outline", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.totalOreText), 1),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "stat-lbl" }, "total ore", -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-calendar-check-outline", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.zileLucrate), 1),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "stat-lbl" }, "zile lucrate", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("mdi-chart-line", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.medieZi), 1),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "stat-lbl" }, "medie / zi", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_v_select, {
          modelValue: _ctx.luna,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.luna) = $event)),
            _ctx.incarca
          ],
          items: _ctx.luni,
          "item-title": "text",
          "item-value": "val",
          label: "Luna",
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          style: {"max-width":"180px"}
        }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]),
        _createVNode(_component_v_select, {
          modelValue: _ctx.an,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.an) = $event)),
            _ctx.incarca
          ],
          items: _ctx.ani,
          label: "An",
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          style: {"max-width":"120px"}
        }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "#ff5722",
            class: "mb-3",
            rounded: "",
            height: "3"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_v_icon, {
            size: "18",
            color: "#ff5722",
            class: "mr-2"
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("mdi-calendar-month-outline", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("span", null, "Calendar " + _toDisplayString(_ctx.lunaText) + " " + _toDisplayString(_ctx.an), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (wd) => {
            return (_openBlock(), _createElementBlock("span", { key: wd }, _toDisplayString(wd), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarCells, (cell, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: _normalizeClass(["cal-cell", { 'is-empty': !cell, 'is-weekend': cell && cell.isWeekend, 'has-hours': cell && cell.ore > 0 }]),
              style: _normalizeStyle(cell && cell.ore > 0 ? { background: _ctx.fillColor(cell.ore) } : {})
            }, [
              cell
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(cell.day), 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(cell.ore > 0 ? cell.oreText : '—'), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ], 6))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_v_icon, {
            size: "18",
            color: "#ff5722",
            class: "mr-2"
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("mdi-format-list-bulleted", -1)
            ]))]),
            _: 1
          }),
          _cache[11] || (_cache[11] = _createElementVNode("span", null, "Detaliu pontaje", -1))
        ]),
        _createVNode(_component_DxDataGrid, {
          "data-source": _ctx.zile,
          "key-expr": "ID",
          "show-borders": false,
          "show-column-lines": false,
          "show-row-lines": true,
          "row-alternation-enabled": true,
          "hover-state-enabled": true,
          "no-data-text": _ctx.loading ? 'Se încarcă…' : 'Nu există pontaj pentru luna selectată.'
        }, {
          dataCell: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_ctx.fmtData(data.data.Data)), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxColumn, {
              "data-field": "Data",
              caption: "Data",
              width: 130,
              "cell-template": "dataCell"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "Intrare",
              caption: "Intrare",
              width: 110
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "Plecare",
              caption: "Plecare",
              width: 110
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "OreLucrate",
              caption: "Ore lucrate",
              width: 120
            }),
            _createVNode(_component_DxPaging, { enabled: false })
          ]),
          _: 1
        }, 8, ["data-source", "no-data-text"])
      ])
    ])
  ]))
}